module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0107.jpg?v=d5e3604a";